const params = new Proxy(new URLSearchParams(window.location.search), {
  get: (searchParams, prop) => searchParams.get(prop),
});

const config = {
  desktop: window.location.search.includes('desktop'),
  demo: params.oid==0,
  oid: params.oid,
  uid: params.uid,
  key: params.key,
  sig: params.sig,
  login_url: 'auth/login',
  refill_url: 'deposit',
  server_url: '/pulltab',
  bets: [1, 2, 3, 4, 5, 10, 15, 20, 30, 40, 50, 100]
};

export default config;



// WEBPACK FOOTER //
// ../base/js/config.js